import React, { useContext, useEffect } from 'react'
import { Box, Container, Toolbar, Typography } from '@material-ui/core';
import { AppContext } from '../app/AppContext';
import { MainHeader } from '../components/MainHeader';
import { types } from '../types/types';

const Imgs = require.context( '../assets', true )

export const AboutPage = () => {
  const { dispatch, cssPage } = useContext( AppContext )
  const css = cssPage()
  const fondo = Imgs('./fondos/main_fondo.png').default

  useEffect(
    () => {
      dispatch({
        type: types.setAll,
        payload: { app: { name: 'Conócenos' } }
      })
      return () => {
        
      }
    },
  // eslint-disable-next-line
  []
  )

  return (
    <div
      className={ css.padre }
      style={{ backgroundImage: `url(${ fondo })`, backgroundSize: '100% 100%' }}
    >
      <Toolbar id="top-about" />
      <MainHeader title="Conócenos" />
      <main className={ css.mainF }>
        <Container className={ css.contentF + ' ' + css.scroll }>
          <Box>
            <Typography variant="h6">Acerca de nosotros</Typography>
          </Box>
        </Container>
      </main>
      <Toolbar id="bot-amazon" />
    </div>
  )
}
